<template>
  <div class="about-content">
    <div class='about-container max-width'>
      <common-title
        title="ABOUT"
        subTitle="US"
        contentTitle="关于我们"
        content='
          厦门久凌科技集团有限公司（简称“久凌科技”）成立于2019年，地处海上花园厦门的标志性建筑——华润万象城办公楼A座。
          作为厦门国资委投资的高新技术企业，集团专注于大型政企、军工系统集成整体解决、软件开发、机房建设、服务器等保、
          数据中小建设，信息化整体解决等模块。'
      >
      </common-title>
    </div>
  </div>
</template>
<script>
import commonTitle from "@/components/commonTitle.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    commonTitle
  },
  computed: {
    ...mapGetters("about",["aboutInfo"])
  },
  methods:{
    ...mapActions("about", ['initData'])
  },
  created(){
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.about-content {
  margin: auto;
  padding-top: 20vh;
  background-color: #fff;
  .about-container{
    max-width: 1366px;
    margin: auto;
  }
}
</style>